import Modal from "@atoms/Modal/Modal";
import SelectBox from "@atoms/SelectBox/SelectBox";
import useModal from "@hooks/useModal";
import IconFilterClassification from "@images/pressList/icon-filter-classification-white.svg";
import IconFilterStatus from "@images/pressList/icon-filter-status-white.svg";
import { usePublicationListFilterState } from "@stores/publicationList";

import PublicationListSearch from "./components/PublicationListSearch/PublicationListSearch";
import PublicationListSearchResult from "./components/PublicationListSearchResult/PublicationListSearchResult";
import StatusFilter from "./components/StatusFilter/StatusFilter";
import TopicTypeFilter from "./components/topicTypeFilter/TopicTypeFilter";
import * as S from "./PublicationListTableFilter.style";

const LIMIT_NUMBER_LIST = [20, 40, 60, 80, 100];

const PublicationListTableFilter = () => {
  const [publicationListFilter, setPublicationListFilter] =
    usePublicationListFilterState();

  const { pageLimit, status, topicType } = publicationListFilter;

  const {
    isModal: isTopicTypeFilterModalOpen,
    openModal: openTopicTypeFilterModal,
    closeModal: closeTopicTypeFilterModal,
  } = useModal();

  const {
    isModal: isStatusFilterModalOpen,
    openModal: openStatusFilterModal,
    closeModal: closeStatusFilterModal,
  } = useModal();

  const selectedClassificationNumber = topicType.length;

  const selectedStatusNumber = status.length;

  const handleSelectLimitNumber = (value: string) => {
    setPublicationListFilter({
      ...publicationListFilter,
      pageLimit: Number(value),
      page: 1,
    });
  };

  return (
    <>
      <S.PressListTableFilterWrapper>
        <S.FilterContainer>
          <S.LeftControls>
            <PublicationListSearch />
            <S.FilterButtonsContainer>
              <S.FilterButton
                buttonWidth={14.8}
                buttonSize="xSmall"
                buttonStyle="solidSky"
                onClick={openTopicTypeFilterModal}
              >
                <img src={IconFilterClassification} alt="topic type filter" />
                Topic Type Filter
                {selectedClassificationNumber > 0 &&
                  `(${selectedClassificationNumber})`}
              </S.FilterButton>
              <S.FilterButton
                buttonSize="xSmall"
                buttonStyle="solidBlueGreen"
                onClick={openStatusFilterModal}
              >
                <img src={IconFilterStatus} alt="status filter" />
                Status Filter
                {selectedStatusNumber > 0 && `(${selectedStatusNumber})`}
              </S.FilterButton>
            </S.FilterButtonsContainer>
          </S.LeftControls>
          <S.RightControls>
            <SelectBox
              optionList={LIMIT_NUMBER_LIST}
              defaultText=" accounts per page"
              selectValue={pageLimit}
              onChangeOption={handleSelectLimitNumber}
            />
          </S.RightControls>
        </S.FilterContainer>

        {isTopicTypeFilterModalOpen && (
          <Modal closeModal={closeTopicTypeFilterModal}>
            <TopicTypeFilter closeModal={closeTopicTypeFilterModal} />
          </Modal>
        )}

        {isStatusFilterModalOpen && (
          <Modal closeModal={closeStatusFilterModal}>
            <StatusFilter closeModal={closeStatusFilterModal} />
          </Modal>
        )}
      </S.PressListTableFilterWrapper>
      <PublicationListSearchResult />
    </>
  );
};

export default PublicationListTableFilter;
